"use client";

import { Proposal } from "@entities/proposal";
import { Vacancy } from "@entities/vacancy";
import { useClientRest } from "@shared/hooks";
import { toSnake } from "@shared/utils";
import { useMutation } from "@tanstack/react-query";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@ubud-ui/react-ui-kit";
import { useState } from "react";

type Payload = {
  vacancy: string;
};

export function DefaultApplyAction({ vacancy, onSucceed }: { vacancy: Vacancy; onSucceed: (response: Proposal) => void }) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { request } = useClientRest();
  const { mutate, isPending } = useMutation<unknown, Error, Payload>({
    mutationKey: ["default-apply-vacancy-action-" + vacancy.id],
    mutationFn: (payload) =>
      request({
        url: `/karirhub/recruitment/v2/industrial-vacancies/${vacancy.vacancyableId}/apply`,
        method: "POST",
        payload: payload,
        options: {
          cache: "no-store",
        },
      }),
  });
  const handleApply = () => {
    mutate(
      toSnake({
        vacancy: vacancy.id,
      }),
      {
        onSuccess: (response: any) => {
          if (response && response.data) {
            setIsOpen(false);
            onSucceed(response.data);
          }
        },
      },
    );
  };

  return (
    <div>
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogTrigger asChild>
          <Button className="font-bold w-full flex text-base p-6">Lamar Sekarang</Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader className="text-left">
            <DialogTitle className="text-xl">Konfirmasi Melamar Lowongan: {vacancy.title}</DialogTitle>
            <DialogDescription>Apakah Anda yakin untuk melamar pada lowongan ini?</DialogDescription>
          </DialogHeader>
          <DialogFooter className="mt-4">
            <div className="flex items-center justify-end">
              <Button className="font-bold text-base p-6" onClick={handleApply} disabled={!!isPending}>
                {isPending ? "Sedang melamar..." : "Lamar Lowongan"}
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
